<template>
  <div class="bar-wrap" v-if="activeIndex !== -1">
    <!-- eslint-disable -->
    <div
      class="item"
      v-for="(item, i) in bars"
      v-if="item.power.includes(role)"
      :key="i"
      @click="targetToPage(item.path)"
    >
      <img :src="activeIndex === i ? item.aIcon : item.icon" alt="" />
      <p :class="activeIndex === i ? 'Selected' : 'Unselected'">
        {{ item.name }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    $route: {
      handler: function (val) {
        const path = val.path;
        if (path === "/") {
          this.activeIndex = 0;
          return;
        } else if (path === "/home/activity") {
          this.activeIndex = 1;
          return;
        } else if (path === "/home/remark") {
          this.activeIndex = 2;
          return;
        } else if (path === "/home/statistics") {
          this.activeIndex = 3;
          return;
        } else if (path === "/home/expert") {
          this.activeIndex = 4;
          return;
        } else if (path === "/mine/index") {
          this.activeIndex = 5;
          return;
        }
        if (path.indexOf("index") === -1) {
          this.activeIndex = -1;
          return;
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      activeIndex: 0,
      role: -1,
      bars: [
        {
          icon: require("../../assets/images/bottom-bar/menu-home.png"),
          aIcon: require("../../assets/images/bottom-bar/menu-home-a.png"),
          path: "/",
          power: [-1, 0, 2, 3],
          name: "首页"
        },
        {
          icon: require("../../assets/images/bottom-bar/menu-active.png"),
          aIcon: require("../../assets/images/bottom-bar/menu-active-a.png"),
          path: "/home/activity",
          power: [-1, 0],
          name: "我的作品"
        },
        {
          icon: require("../../assets/images/bottom-bar/menu-remark.png"),
          aIcon: require("../../assets/images/bottom-bar/menu-remark-a.png"),
          path: "/home/remark",
          power: [1],
          name: "点评"
        },
        {
          icon: require("../../assets/images/bottom-bar/statistics-ico.png"),
          aIcon: require("../../assets/images/bottom-bar/statistics-ico-a.png"),
          path: "/home/statistics",
          power: [2],
          name: "统计"
        },
        {
          icon: require("../../assets/images/bottom-bar/expert-ico.png"),
          aIcon: require("../../assets/images/bottom-bar/expert-ico-a.png"),
          path: "/home/expert",
          power: [3],
          name: "专家"
        },
        {
          icon: require("../../assets/images/bottom-bar/menu-mine.png"),
          aIcon: require("../../assets/images/bottom-bar/menu-mine-a.png"),
          path: "/mine/index",
          power: [-1, 0, 1, 2, 3],
          name: "我的"
        }
      ]
    };
  },
  methods: {
    targetToPage(path) {
      this.$router.push(path);
    }
  },
  created() {
    this.role = this.$store.state.role;
  }
};
</script>

<style lang="scss" scoped>
.bar-wrap {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  background-color: #fff;
  height: 70px;
  width: 10rem;
  bottom: 0;
  border-top: 1px solid #f2f2f2;
  box-shadow: 0 -3px 8px #f6f6f666;
  z-index: 100;
  left: calc((100vw - 10rem) / 2);
  .item {
    height: 100%;
    width: 75px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      max-width: 21px;
      max-height: 21px;
    }
    p {
      font-size: 12px;
      color: #666;
    }
    .Selected{
      font-size: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      color: #31D076;
    }
    .Unselected{
      font-size: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>
